import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input } from 'antd';
import { isEmpty } from 'utils/utils';
import { DatePicker } from 'components/atoms';
import moment from 'moment';

export interface RefCodeEditModalProps extends PopupProps {
    title: string;
    ref_code_srl: number;
    value?: string;
    created?: string;
    useCreate?: boolean;
}

const RefCodeEditModal = ({ isOpen, onClose, title, ref_code_srl, value, created, useCreate = false }: RefCodeEditModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [isFormDone, setIsFormDone] = useState<boolean>(false);
   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */
    const onCancel = () => {
        onClose?.(false);
    };
        
    const onSubmit = (e) => {
        if (useCreate) {
            onClose?.(true, e.value, e.created);
        } else {
            onClose?.(true, e.value);
        }
      };

    const onChangeForm = () => { 
        if (useCreate) {
            setIsFormDone(!(isEmpty(form.getFieldValue('value')) || form.getFieldValue('created') === 'Invalid date'));
        } else {
            setIsFormDone(!isEmpty(form.getFieldValue('value')));
        }
    };      
   
  /* ======================================================
   * effects
   * ====================================================== */

    useEffect(() => {
        form.setFieldsValue({
            value: value || '',
            created: created || moment().format('YYYY-MM-DD'),
        });
    }, []);

    return (
        <ModalWrapper open={isOpen} onCancel={onCancel} width={450} title={title + ' ' + (ref_code_srl===0?'등록':'수정')} closable>
            <Form
                form={form}
                name="RefCode"
                layout="horizontal"  
                labelCol={{ flex: '125px' }}
                onFieldsChange={onChangeForm}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Form.Item name="value" label={title + '명'} rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder={title + '명을 입력하세요'}/>                    
                </Form.Item>    
                {(useCreate) && (
                    <Form.Item
                        name="created"
                        label={'생성일'}
                        rules={[{ required: true, message: '' }]}
                        getValueProps={(i) => ({value: i!=='Invalid date'? moment(i): ''})}
                        getValueFromEvent={(onChange) => moment(onChange).format('YYYY-MM-DD')}
                    >
                        <DatePicker 
                            showTime={false}
                            format="YYYY-MM-DD"
                        />    
            
                    </Form.Item>                    
                )}                 
                <ButtonGroup className={'buttonsWrapper'}>
                    <Button onClick={onCancel}>취소</Button>
                    <Button htmlType="submit"  type="primary" disabled={!isFormDone}>{ref_code_srl===0?'등록':'수정'}</Button>
                </ButtonGroup>                
            </Form>
        </ModalWrapper>  
    )    
};

export default React.memo(RefCodeEditModal);    